import { render, staticRenderFns } from "./QuantityCurrentYearInformation.vue?vue&type=template&id=2494758d&"
import script from "./QuantityCurrentYearInformation.vue?vue&type=script&lang=ts&"
export * from "./QuantityCurrentYearInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports